import { render } from "./StoreInfoPage.vue?vue&type=template&id=04d2fd1a&scoped=true"
import script from "./StoreInfoPage.vue?vue&type=script&lang=js"
export * from "./StoreInfoPage.vue?vue&type=script&lang=js"

import "./StoreInfoPage.vue?vue&type=style&index=0&id=04d2fd1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d2fd1a"]])

export default __exports__